"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorefrontSortingSetting = exports.SalesTeamSize = exports.CatalogSize = exports.DiscoveryChannel = exports.SalesDistributionMode = exports.OnlineSalesChannel = exports.FeedbackRatingGroup = exports.StoreStatus = exports.Theme = exports.ECompanySize = void 0;
var ECompanySize;
(function (ECompanySize) {
    ECompanySize["Micro"] = "MICRO";
    ECompanySize["Small"] = "SMALL";
    ECompanySize["Medium"] = "MEDIUM";
    ECompanySize["Large"] = "LARGE";
})(ECompanySize || (exports.ECompanySize = ECompanySize = {}));
/**
 * These theme names were generated based on the primary color using the Name That Color vscode extension.
 * https://marketplace.visualstudio.com/items?itemName=guillaumedoutriaux.name-that-color
 */
//
var Theme;
(function (Theme) {
    Theme["Sushi"] = "SUSHI";
    Theme["PuertoRico"] = "PUERTO_RICO";
    Theme["SteelBlue"] = "STEEL_BLUE";
    Theme["Studio"] = "STUDIO";
    Theme["Cerise"] = "CERISE";
    Theme["BrickRed"] = "BRICK_RED";
    Theme["Tuscany"] = "TUSCANY";
    Theme["Dixie"] = "DIXIE";
    Theme["IrishCoffee"] = "IRISH_COFFEE";
    Theme["BaliHai"] = "BALI_HAI";
    Theme["Cobalt"] = "COBALT";
    Theme["CodGray"] = "COD_GRAY";
})(Theme || (exports.Theme = Theme = {}));
/**
 * Possible states of a store, might be changed by an admin, due to contract updates, or inactivity.
 */
var StoreStatus;
(function (StoreStatus) {
    /**
     * The store is active, with its contract in a valid state that allows it to operate normally.
     */
    StoreStatus["Active"] = "ACTIVE";
    /**
     * The store has been temporarily suspended, usually, it happens due to lack of payment.
     */
    StoreStatus["Suspended"] = "SUSPENDED";
    /**
     * The store hasn't been active recently, the store is set as inactive after 45 days without a login.
     */
    StoreStatus["Inactive"] = "INACTIVE";
    /**
     * The store has been archived and is no longer accessible, the store data was also archived or deleted.
     */
    StoreStatus["Archived"] = "ARCHIVED";
    /**
     * The store has been blocked due to some terms and conditions violation, it might get `Archived` if the violation isn't resolved after some time.
     */
    StoreStatus["Blocked"] = "BLOCKED";
})(StoreStatus || (exports.StoreStatus = StoreStatus = {}));
var FeedbackRatingGroup;
(function (FeedbackRatingGroup) {
    FeedbackRatingGroup["Detractor"] = "DETRACTOR";
    FeedbackRatingGroup["Passive"] = "PASSIVE";
    FeedbackRatingGroup["Promoter"] = "PROMOTER";
})(FeedbackRatingGroup || (exports.FeedbackRatingGroup = FeedbackRatingGroup = {}));
var OnlineSalesChannel;
(function (OnlineSalesChannel) {
    OnlineSalesChannel["WhatsApp"] = "WHATSAPP";
    OnlineSalesChannel["SocialMedia"] = "SOCIAL_MEDIA";
    OnlineSalesChannel["OwnWebsite"] = "OWN_WEBSITE";
    OnlineSalesChannel["Marketplaces"] = "MARKETPLACES";
    OnlineSalesChannel["NotSellingOnline"] = "NOT_SELLING_ONLINE";
})(OnlineSalesChannel || (exports.OnlineSalesChannel = OnlineSalesChannel = {}));
var SalesDistributionMode;
(function (SalesDistributionMode) {
    SalesDistributionMode["Wholesale"] = "WHOLESALE";
    SalesDistributionMode["Retail"] = "RETAIL";
    SalesDistributionMode["Both"] = "BOTH";
})(SalesDistributionMode || (exports.SalesDistributionMode = SalesDistributionMode = {}));
var DiscoveryChannel;
(function (DiscoveryChannel) {
    DiscoveryChannel["Friends"] = "FRIENDS";
    DiscoveryChannel["Google"] = "GOOGLE";
    DiscoveryChannel["Facebook"] = "FACEBOOK";
    DiscoveryChannel["Twitter"] = "TWITTER";
    DiscoveryChannel["LinkedIn"] = "LINKEDIN";
    DiscoveryChannel["Instagram"] = "INSTAGRAM";
    DiscoveryChannel["TikTok"] = "TIKTOK";
    DiscoveryChannel["YouTube"] = "YOUTUBE";
    DiscoveryChannel["Podcast"] = "PODCAST";
    DiscoveryChannel["Events"] = "EVENTS";
    DiscoveryChannel["Other"] = "OTHER";
})(DiscoveryChannel || (exports.DiscoveryChannel = DiscoveryChannel = {}));
var CatalogSize;
(function (CatalogSize) {
    CatalogSize["ServicesOnly"] = "SERVICES_ONLY";
    CatalogSize["OneToTen"] = "ONE_TO_TEN";
    CatalogSize["TenToSixty"] = "TEN_TO_SIXTY";
    CatalogSize["SixtyToOneTwenty"] = "SIXTY_TO_ONE_TWENTY";
    CatalogSize["MoreThanOneTwenty"] = "MORE_THAN_ONE_TWENTY";
})(CatalogSize || (exports.CatalogSize = CatalogSize = {}));
var SalesTeamSize;
(function (SalesTeamSize) {
    SalesTeamSize["OnlyMe"] = "ONLY_ME";
    SalesTeamSize["OneToFive"] = "ONE_TO_FIVE";
    SalesTeamSize["SixToTen"] = "SIX_TO_TEN";
    SalesTeamSize["ElevenToFifty"] = "ELEVEN_TO_FIFTY";
    SalesTeamSize["MoreThanFifty"] = "MORE_THAN_FIFTY";
})(SalesTeamSize || (exports.SalesTeamSize = SalesTeamSize = {}));
/**
 * Default sorting order for products displayed in the store's catalog.
 * This setting determines how items are organized when customers browse the storefront.
 */
var StorefrontSortingSetting;
(function (StorefrontSortingSetting) {
    /**
     * Sort products alphabetically from A to Z (default).
     */
    StorefrontSortingSetting["AlphabeticalAToZ"] = "ALPHABETICAL_A_TO_Z";
    /**
     * Sort products alphabetically from Z to A.
     */
    StorefrontSortingSetting["AlphabeticalZToA"] = "ALPHABETICAL_Z_TO_A";
    /**
     * Sort products by price from highest to lowest.
     */
    StorefrontSortingSetting["PriceHighToLow"] = "PRICE_HIGH_TO_LOW";
    /**
     * Sort products by price from lowest to highest.
     */
    StorefrontSortingSetting["PriceLowToHigh"] = "PRICE_LOW_TO_HIGH";
    /**
     * Sort products by most recently updated or created first.
     */
    StorefrontSortingSetting["MostRecent"] = "MOST_RECENT";
})(StorefrontSortingSetting || (exports.StorefrontSortingSetting = StorefrontSortingSetting = {}));
//# sourceMappingURL=store.js.map